<!-- Zweck: Stellt die HTML-Struktur für shop merkliste menu component im Frontend bereit. -->
<div class="mlmenu">
  @if (!add_mode) {
    <div>
      <div class="title">Merkliste auswählen</div>
      @for (ml of mlsvc.merklisten$|async; track ml) {
        <div (click)="addToMerkliste(ml)" class="menuitem">
          @if ((mlsvc.primary_merkliste$|async) && (mlsvc.primary_merkliste$|async)?.id == ml.id) {
            <svg-icon
              style="font-size: 12px; height: 12px">radiobutton-gefuellt
            </svg-icon>
          }
          @if ((mlsvc.primary_merkliste$|async) && (mlsvc.primary_merkliste$|async)?.id != ml.id) {
            <svg-icon
              style="font-size: 12px; height: 12px">radiobutton-leer
            </svg-icon>
          }
          @if (ml.readonly_impersonation_workspace) {
            <mat-icon matTooltip="Temporäre Merkliste der Read-only-Impersonation" aria-label="Temporäre Merkliste der Read-only-Impersonation">schedule</mat-icon>
          }
          {{ml.label}}
        </div>
      }
      <div class="spacer"></div>
      <div (click)="add()" class="menuitem">
        <svg-icon>merkliste-hinzufuegen</svg-icon>
        Neue Merkliste
      </div>
    </div>
  }
  @if (add_mode) {
    <div>
      <div class="title">Neue Merkliste</div>
      <div class="paddedcontent">
        <mat-form-field appearance="outline">
          <input [(ngModel)]="newml.label" matInput
            placeholder="Bezeichnung">
        </mat-form-field>
        <br>
          @if (!(usvc.user$|async)?.readonly_impersonated) {
            <mat-checkbox [(ngModel)]="newml.shared">Geteilt</mat-checkbox>
          }
          <hr>
            <button (click)="save()" mat-button>
              <svg-icon>speichern</svg-icon>
              Speichern & Hinzufügen
            </button>
            <button (click)="cancel()" mat-button>
              <svg-icon>abbrechen</svg-icon>
              Abbrechen
            </button>
          </div>
        </div>
      }
    </div>
